import { Modal } from "react-bootstrap";
import React, { useEffect, useRef } from "react";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../../features/RadConnStyle";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setReminder } from "../../../features/UserActions";

export default function ImageCapture(props) {
  const dispatch = useDispatch();

  let videoRef = useRef(null);
  let photoRef = useRef(null);

  const getUserCamera = () => {
    console.log(navigator);
    try {
      navigator.mediaDevices
        .getUserMedia({
          video: true,
        })
        .then((stream) => {
          let video = videoRef.current;
          video.srcObject = stream;
          video.play();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const stopCamera = () => {
    let video = videoRef.current;
    let stream = video.srcObject;

    try {
      let tracks = stream?.getTracks();
      tracks?.forEach((track) => {
        track.stop();
      });
      video.srcObject = null;
      navigator.mediaDevices.getUserMedia({
        video: false,
      });
      props.setCapture(false);
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const takePicture = () => {
    let width = 500;
    // let height = width / (16/9);
    let height = 400;
    let photo = photoRef.current;
    let video = videoRef.current;

    photo.width = width;
    photo.height = height;
    let ctx = photo.getContext("2d");
    ctx.drawImage(video, 0, 0, photo.width, photo.height);
  };

  const clearImage = () => {
    let photo = photoRef.current;
    let ctx = photo.getContext("2d");
    let image = photo.toDataURL("image/png");
    image = image.replace("data:image/png;base64,", "");

    const formData = new FormData();
    formData.append("user", JSON.stringify(props.fields));
    formData.append("image", JSON.stringify({ image: image }));

    axios
      .post(
        process.env.REACT_APP_API + "api/staff/SaveFromCam",
        formData,
        HttpJsonHeader
      )
      .then((res) => {
        props.fields.image_name = res.data;
        props.setStaffImage(process.env.REACT_APP_PHOTO + res.data);
        ctx.clearRect(0, 0, photo.width, photo.height);
        // ctx.drawImage(image);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: "พบปัญหา " + err, type: "error" })
        )
      );
  };

  useEffect(() => {
    if (props.capture) {
      getUserCamera();
    }
  }, [props.capture]);

  return (
    <MyModal show={props.capture} size="sm" closeButton centered>
      <ModalHeaderBlack></ModalHeaderBlack>
      <ModalBodyBlack>
        <MainContainer>
          <VideoBox ref={videoRef}></VideoBox>
          <ButtonCap onClick={takePicture}>Take Photo</ButtonCap>
          <PictureBox ref={photoRef}></PictureBox>
          <ButtonCap onClick={clearImage}> บันทึกภาพ</ButtonCap>
          <ButtonCap
            onClick={() => {
              stopCamera();
            }}
          >
            close
          </ButtonCap>
        </MainContainer>
      </ModalBodyBlack>
    </MyModal>
  );
}

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 30px;
`;

const VideoBox = styled.video`
  width: 200px;
  height: 150px;
  border: 1px solid blue;
  border-radius: 25%;
`;

const PictureBox = styled.canvas`
  width: 200px;
  height: 150px;
  border: 1px solid blue;
  border-radius: 25%;
`;

const ButtonCap = styled.button`
  width: 200px;
  border-radius: 10%;
  border: none;
  margin: 2px;
  color: #b3f255;
  background-image: linear-gradient(#121212, #454545);
  &:hover {
    background-image: linear-gradient(#d0a4a4, #454545);
  }
`;
